import { Discount } from '../../models/discount/discount.interface';

export const mockDiscounts: Discount[] = [
  {
    discountProfileCode: 'ABC123',
    discountTerm: 12,
    discountAmount: 100,
    discountPercentage: 20,
  },
  {
    discountProfileCode: 'DEF456',
    discountTerm: 6,
    discountAmount: 100,
    discountPercentage: 20,
  },
  {
    discountProfileCode: 'GHI789',
    discountTerm: 3,
    discountAmount: 100,
    discountPercentage: 20,
  },
];
